module.exports = __webpack_public_path__ + "Tinebase/js/ace-ext-settings_menu-FAT.js";